import React from "react";

function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-16 h-16 border-4 border-[var(--primary)] border-dashed rounded-full animate-spin"></div>
        <p className="text-gray-700 text-lg font-medium animate-pulse">
          Loading...
        </p>
      </div>
    </div>
  );
}

export default LoadingSpinner;
